import { render, staticRenderFns } from "./Fundings.vue?vue&type=template&id=0279ea12&scoped=true&"
import script from "./Fundings.vue?vue&type=script&lang=js&"
export * from "./Fundings.vue?vue&type=script&lang=js&"
import style0 from "./Fundings.vue?vue&type=style&index=0&id=0279ea12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279ea12",
  null
  
)

export default component.exports